/**
 * 今日到店车两信息
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 车辆信息
Mock.mock(/^\/api\/v1\/cars\/\d+/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'car': {
      'car_id': 1,
      'insurance_expires_in': -15,
      'insurance_expires_on': '2016-10-31',
      'last_insurance_company': null,
      'last_insurance_kinds': [
        {
          id: '111',
          code: 'mb0005',
          name: '车上人员责任保险（乘客）',
          price: null,
          properties: {
            count: 1,
            coverage: '5000',
            unit: '座'
          }
        }, {
          id: '222',
          code: 'zz0019',
          name: '玻璃增值服务',
          price: null,
          properties: {
            glass_type: '国产'
          }
        }, {
          id: '333',
          code: 'mb0002',
          name: '机动车第三者责任保险',
          price: null,
          properties: {
            coverage: '5',
            coverage_unit: '万'
          }
        }
      ],
      'mileag': 0,
      'model_desc': 'lexus ls250',
      'plate_number': '\u7ca4L89757',
      'prepaid_insurance_balance': 58844,
      'served_at': null,
      'sold_at': '2015-10-14',
      'vin': 'JTHBW1GGXF2106586',
      'business_ins_expires_on': '2017-1-20 10:0:0', // 保险到期日
      'business_ins_expires_in': 17, // 保险剩余天数
      'force_ins_expires_on': '2017-1-20 10:0:0', // 交强险到期日
      'force_ins_expires_in': 17 // 交强险保险剩余天数
    }
  },
  'message': 'ok'
})
